import React, { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description: string;
  buttonText: string;
  buttonIcon?: ReactNode;
  onButtonClick: () => void;
  icon?: ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  buttonText,
  buttonIcon,
  onButtonClick,
  icon = <Inbox className="size-12 text-gray-400" />,
}) => (
  <div className="flex flex-col items-center justify-center py-20 text-center">
    <div className="mb-6">{icon}</div>
    <h2 className="mb-2 text-xl font-semibold">{title}</h2>
    <p className="mb-6 text-gray-600">{description}</p>
    <Button onClick={onButtonClick} className="flex items-center">
      {buttonIcon}
      {buttonText}
    </Button>
  </div>
);
